const axios = require("axios");
import store from '../store';

const apiClient = axios.create({
    method: 'get',
    baseURL: process.env.VUE_APP_MOTIFLOW_API,
    timeout: 3000,
});

apiClient.interceptors.request.use(function (config) {
    let authKey = store.state.token;
    if (!authKey) {
        console.warn('No token is set')
    }
    config.headers["authorization"] = authKey;

    let baseURL = store.state.baseURL;
    if (baseURL) {
        console.warn('Custom base url set for Motiflow');
        config.baseURL = "https://"+store.state.baseURL+'/publicApi/v1/'
    }

    return config;
});

export default {
    getPatterns() {
        let _query= [];
        if(store.getters.filterColor){
            _query.push(`colorId=${store.getters.filterColor}`);
        }
        let _search = '';
        if(_query.length){
            _search = _query.join("&");
        }
        return apiClient.get(`/boards/${store.getters.configBoard}/patterns?${_search}`, {});
    },

    getSinglePattern(id){
        let _query= [];
            _query.push(`patternId=${id}`);
        let _search = '';
        if(_query.length){
            _search = _query.join("&");
        }
        return apiClient.get(`/boards/all/patterns?${_search}`, {});

    },

    getPrivatePatterns(){
        let _query= [];
        if(store.getters.filterColor){
            _query.push(`colorId=${store.getters.filterColor}`);
        }
        let _search = '';
        if(_query.length){
            _search = _query.join("&");
        }
        return apiClient.get(`/patterns/own?${_search}`, {});

    },
    getBoards() {
        return apiClient.get(`/boards/`, {});
    },
}